import React from 'react'
import s from './referrals.module.scss'
import { PageTemplate } from '@shared/ui/page-template'
import { FetchingDiv } from '@shared/ui/fetching-div/fetching-div';
import { ReferralModals } from '@widgets/referrals/ui/referral-modals';
import { ProgressReferralCard } from '@widgets/referrals/ui/progress-referral-card/progress-referral-card';
import { LinkReferralCard } from '@widgets/referrals/ui/link-referral-card/link-referral-card';
import { InfoReferralCard } from '@widgets/referrals/ui/info-referral-card/info-referral-card';
import { useHowWorkReferralModal } from '@features/teacher/how-work-referral/model/useHowWorkReferralModal';
import { useHowActiveReferralModal } from '@features/teacher/how-active-referral/model/useHowActiveReferralModal';
import { queryClient } from '../../../shared/api/query-client';
import { useReferralLevels } from '@widgets/referrals/api/useReferralLevels';
import { ReferralTable } from '@widgets/referrals/ui/referral-table/referral-table';

export const ReferralsPage = () => {

	const { open: OpenHowWorkReferralModal } = useHowWorkReferralModal()
	const { open: OpenHowActiveReferralModal } = useHowActiveReferralModal()


	const { data: profile } = queryClient.getQueryData(['profile'])

	const { data: referral_levels, isFetching } = useReferralLevels()


	return (
		<PageTemplate title='Реферальная программа'>
			<FetchingDiv isFetching={isFetching}>
				<ReferralModals/>
				<div className={s.grid}>
					<ProgressReferralCard referral_level={profile?.referral_level} referral_levels={referral_levels}/>
					<LinkReferralCard referral_token={profile?.referral_token}/>
					<ReferralTable/>
					<div className={s.info}>
						<h2>Все о реферальной системе</h2>
						<div className={s.cards}>
							<InfoReferralCard
							openModal={OpenHowWorkReferralModal}
							label='Как работает реферальная система?'
							description='Приглашайте преподавателей на «Созвучно» по своей реферальной ссылке и снижайте свою комиссию. Чем больше активных рефералов вы привлекаете, тем ниже ваша комиссия — от 15% до 5%.'
							/>
							<InfoReferralCard
							openModal={OpenHowActiveReferralModal}
							label='Как считается активный пользователь?'
							description='Реферал считается активным, если он провёл не менее 3 платных занятий за последние 2 месяца. Именно активные рефералы учитываются при определении вашей комиссии.'
							/>
						</div>
					</div>
				</div>
			</FetchingDiv>
		</PageTemplate>
	)
}
